import { render, staticRenderFns } from "./ConfirmaResultado.vue?vue&type=template&id=4653e47d"
import script from "./ConfirmaResultado.vue?vue&type=script&lang=js"
export * from "./ConfirmaResultado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports